var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyPerformance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48583 0 0 4.48583 0 10C0 15.5142 4.48583 20 10 20C15.5142 20 20 15.5142 20 10C20 4.48583 15.5142 0 10 0ZM13.2183 11.6667C13.3717 12.2542 13.37 12.8717 13.19 13.4675C12.9308 14.32 12.3567 15.02 11.5717 15.44C11.0925 15.6967 10.5492 15.8333 10.0033 15.8333C8.76917 15.8333 7.64083 15.1575 7.06083 14.0708C6.98917 13.9358 6.83417 13.6408 6.18583 11.6667H1.835C1.725 11.1283 1.66667 10.5708 1.66667 10C1.66667 5.405 5.405 1.66667 10 1.66667C14.595 1.66667 18.3333 5.405 18.3333 10C18.3333 10.5708 18.275 11.1283 18.165 11.6667H13.2183Z",
    fill: "#4E5459"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98998 6.00083C6.86415 5.84583 6.64665 5.80166 6.47081 5.89666C6.29498 5.99083 6.21081 6.19583 6.26831 6.38583C6.46498 7.02666 8.19498 12.6592 8.53081 13.2858C8.82998 13.8467 9.40748 14.1667 10.0033 14.1667C10.2683 14.1667 10.5375 14.1033 10.7858 13.97C11.5975 13.5367 11.9041 12.525 11.4708 11.7142C11.1358 11.0883 7.41331 6.51916 6.98998 6.00083Z",
    fill: "#9CA2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyPerformance);
export default __webpack_public_path__ + "static/media/company-performance.0bd7954b1c2cc05ba4f54cdd35ea0743.svg";
export { ForwardRef as ReactComponent };